import React from 'react';
import PropTypes from 'prop-types';

import TooltipWrapper from '../TooltipWrapper';
import FormLabel from './FormLabel';

function FormControlLabel({
  mouseInKey,
  linkTo,
  linkEnabled,
  placement,
  isRequired,
  title,
  isValid
}) {
  const formLabel = <FormLabel isRequired={isRequired} title={title} isValid={isValid} />;

  if (mouseInKey.length > 0) {
    return (
      <TooltipWrapper
        tooltipContent={mouseInKey}
        linkTo={linkTo}
        linkEnabled={linkEnabled}
        placement={placement}
      >
        {formLabel}
      </TooltipWrapper>
    );
  }

  return formLabel;
}

FormControlLabel.propTypes = {
  mouseInKey: PropTypes.string,
  linkTo: PropTypes.string,
  linkEnabled: PropTypes.bool,
  placement: PropTypes.string,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  title: PropTypes.string
};
FormControlLabel.defaultProps = {
  mouseInKey: '',
  linkTo: '',
  linkEnabled: false,
  placement: 'bottom',
  isRequired: false,
  isValid: true,
  title: ''
};


export default FormControlLabel;
